import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HTTP_METHODS } from '@common/services/service.constant';
import { AbstractService } from '@common/services/abstract.service';
import { EncryptionProviderService } from '@common/services/encryption.service';
import { Observable } from 'rxjs';
import { Platform, AlertController } from '@ionic/angular';
import { CommonService } from '@common/services/common.service';
import { Device } from '@ionic-native/device/ngx';

@Injectable({
  providedIn: 'root'
})

export class UserFeedbackService extends AbstractService<any> {

  constructor(
    http: HttpClient,
    encryptionProviderService: EncryptionProviderService,platform: Platform,alertController:AlertController,commonService:CommonService, device:Device ){
    super(http, encryptionProviderService,platform,alertController,commonService,device);
}

  //--------------Update User feedback API
  public updateUserFeedback(data): Observable<any> {
    const url = '/transaction/feedback'
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}`,
      body: data
    });
  }
}
